import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { markFormGroupTouched } from 'src/app/controls/functions/shared-functions';
import { getInvalidFieldsV2, jsonDeepParse, prepareFieldConfigFlagsNew } from 'src/app/functions/shared-functions';
import { ConfirmationComponent } from 'src/app/modules/shared/confirmation/confirmation.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';

@Component({
  selector: 'app-resume-nominee',
  templateUrl: './resume-nominee.component.html',
  styleUrls: ['./resume-nominee.component.scss'],
})
export class ResumeNomineeComponent implements OnInit {

  master_data: any = {};
  nomForm: UntypedFormGroup = new UntypedFormGroup({
    relationTypeId: new UntypedFormControl(null),         // master: relationTypeMasterList jaggu add in all master api
    name: new UntypedFormControl(null),
    dob: new UntypedFormControl(null),
    age: new UntypedFormControl(null),
    bloodGroup: new UntypedFormControl(null),              // bloodGroupMasterList jaggu add in all master
    address: new UntypedFormControl(null),
    percentageShare: new UntypedFormControl(null),
  })

  exp_list = []
  validUploaded: boolean = true;
  all_rights: any = {};
  field_config_access: any = {};
  id = 0;
  jobseeker = {
    selected_jobtitle: [],
    jobTitleList: [],
    jobTitleMasters: {
      take: 100,
      skip: 0,
      totalcount: 0
    },
  }
  selected_designation
  date = new Date();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog_ref: MatDialogRef<ResumeNomineeComponent>,
    private dialog: MatDialog,
    private notification: NotificationService,
    private translate: TranslateService,
    // private resume_srv: ResumeService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      if (this.data.id) {
        this.id = this.data.id
      }
      this.master_data = this.data.master_data;
      this.exp_list = jsonDeepParse(this.data.list) || [];
      console.log(this.master_data)
      this.all_rights = this.data.all_rights;
      if (this.all_rights) {
        this.field_config_access = prepareFieldConfigFlagsNew(this.all_rights, this.nomForm, null, 'RES-nom_')
      }
    }


  }
  close() {
    this.dialog_ref.close()
  }
  save() {
    if (this.validUploaded) {
      this.dialog_ref.close(this.exp_list)
    }
    else {
      this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
    }
  }

  addExperience() {
    if (this.nomForm.valid) {
      if (this.exp_list && this.exp_list.length) {
        this.exp_list.push(this.nomForm.value);
      }
      else {
        this.exp_list = [this.nomForm.value];
      }
      this.nomForm.reset();

    }
    else {
      if (!this.validUploaded) {
        this.notification.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
        return;
      }
      else {
        markFormGroupTouched(this.nomForm)
        getInvalidFieldsV2(this.nomForm, this.translate, this.notification, 'RESUME.', null, this.field_config_access, 'RES-nom_')
      }
    }

  }

  editExperience(index) {
    this.nomForm.patchValue(this.exp_list[index]);
    this.exp_list.splice(index, 1);
  }
  deleteExperience(index) {
    this.dialog
      .open(ConfirmationComponent, {
        width: "480px",
        height: "auto",
        panelClass: "icr-dialog",
        data: {
          title: "CONFIRMATION.confirmation",
          message: "CONFIRMATION.are_you_sure_to_delete",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.exp_list.splice(index, 1);
        }
      });
  }
  uploadedStatus(ev) {
    this.validUploaded = ev
  }
  viewAttachments(list) {
    viewDocument(list, list[0], this.dialog)
  }

}

function viewDocument(list: any, arg1: any, dialog: MatDialog) {
  throw new Error('Function not implemented.');
}

